import { useMemo } from 'react'

import {
  PayrollConceptSelectFieldFragment,
  PayrollValueObjectsConceptCategoryEnum,
} from 'generated/resources/graphql'

import { DEFAULT_RESULT_CONCEPT } from 'modules/payroll_bundle/lib/constants'

interface PayrollConceptWithCategory {
  label: string
  value: string
  name: string
  category?: PayrollValueObjectsConceptCategoryEnum | null
}

const useCategorizedPayrollConcepts = (
  payrollConcepts: PayrollConceptSelectFieldFragment[],
  options?: { excludeBaseSalary?: boolean }
) => {
  const { excludeBaseSalary = true } = options || {}

  const categorizedPayrollConcepts: PayrollConceptWithCategory[] = useMemo(() => {
    return payrollConcepts
      .filter(
        (payrollConcept) =>
          !excludeBaseSalary || payrollConcept.name !== DEFAULT_RESULT_CONCEPT.base_salary
      )
      .map((payrollConcept) => {
        const { id, category, label, name } = payrollConcept
        return { label, value: id, name, category }
      })
  }, [payrollConcepts, excludeBaseSalary])

  return categorizedPayrollConcepts
}

export type { PayrollConceptWithCategory }
export { useCategorizedPayrollConcepts }
